import React from 'react'

export default function EmbSpecial() {
  return (
    <div>
          <><section className="page-center padding40tb">
          <header>
              <h2>Specialty Embroidery</h2>
          </header>

          <div className="embroidery-intro">
              <h3>Make Our Specialty Yours</h3>
              <p>
                  Adding embroidery elements to your garment ensures a professional, polished look that highlights your personal or business brand.
                  Embroidered garments are a stylish way to showcase your organization and its members.
              </p>
          </div>

          <div className="embroidery-types">
              <p><strong>5 Types of Specialty Embroidery:</strong></p>
              <ul>
                  <li><span style={{ color: '#c43235' }}>Superior Quality Lettering</span></li>
                  <li><span style={{ color: '#c43235' }}>Gradient Embroidery</span></li>
                  <li><span style={{ color: '#c43235' }}>Textured Embroidery</span></li>
                  <li><span style={{ color: '#c43235' }}>Puff Embroidery</span></li>
                  <li><span style={{ color: '#c43235' }}>Applique</span></li>
              </ul>
          </div>
      </section>
      <div className="row-fluid-wrapper row-depth-1 row-number-12 ">
              <div className="row-fluid ">
                  <div className="span12 widget-span widget-type-cell " style={{}} data-widget-type="cell" data-x="0" data-w="12">
               <div className="embroidery-section my-6 md:my-8">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
        {/* Image */}
        <div className="flex-shrink-0">
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Specialty_Embroidery/Embroidery_Specialty_Superior_Quality_Lettering_Sharprint_Chicago.jpg?width=300&name=Embroidery_Specialty_Superior_Quality_Lettering_Sharprint_Chicago.jpg"
            alt="Superior Quality Lettering"
            title="Superior Quality Lettering"
            className="w-72 md:w-80 border-0"
          />
        </div>

        {/* Text */}
        <div className="flex-1">
          <h4>Superior Quality Lettering</h4>
          <p>
            Trends come and go, but mastery of the fundamentals never goes out of style. 
            We specialize in the cleanest, tightest fine lettering, even as small as 0.25” tall, 
            to ensure your design looks crisp and professional.
          </p>
        </div>
      </div>
    </div>
    <div className="embroidery-spacer my-6 md:my-8">
      {/* Empty space for layout spacing */}
      <div style={{ height: '25px' }}></div>
    </div>
    <div className="embroidery-section my-6 md:my-8">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
        {/* Image */}
        <div className="flex-shrink-0">
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Specialty_Embroidery/Embroidery_Specialty_Gradient_Embroidery_Sharprint_Chicago.jpg?width=300&name=Embroidery_Specialty_Gradient_Embroidery_Sharprint_Chicago.jpg"
            alt="Gradient Embroidery"
            title="Gradient Embroidery"
            className="w-72 md:w-80 border-0"
          />
        </div>

        {/* Text */}
        <div className="flex-1">
          <h4>Gradient Embroidery</h4>
          <p>
            Gradient effects aren’t just for screen printing. Our skilled digitizers recreate complex gradient designs 
            and logos daily, allowing us to embroider them beautifully on caps, bags, polos, fleece, towels, and more.
          </p>
        </div>
      </div>
      
    </div>
    <div className="embroidery-spacer my-6 md:my-8">
      {/* Empty space for layout spacing */}
      <div style={{ height: '25px' }}></div>
    </div>
    <div className="embroidery-section my-6 md:my-8">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
        {/* Image */}
        <div className="flex-shrink-0">
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Specialty_Embroidery/Embroidery_Specialty_Textured_Embroidery_Sharprint_Chicago.jpg?width=300&name=Embroidery_Specialty_Textured_Embroidery_Sharprint_Chicago.jpg"
            alt="Textured Embroidery"
            title="Textured Embroidery"
            className="w-72 md:w-80 border-0"
          />
        </div>

        {/* Text */}
        <div className="flex-1">
          <h4>Textured Embroidery</h4>
          <p>
            Repeating shapes in embroidery create a rich texture with softness and flexibility. 
            This style works best for logos or designs using one or two colors. 
            Let our graphic designers craft a unique textured embroidery design just for you!
          </p>
        </div>
      </div>
    </div>
    <div className="embroidery-spacer my-6 md:my-8">
      {/* Empty space for layout spacing */}
      <div style={{ height: '25px' }}></div>
    </div>
    <div className="embroidery-section my-6 md:my-8">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
        {/* Image */}
        <div className="flex-shrink-0">
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Specialty_Embroidery/Embroidery_Specialty_Puff_Embroidery_Sharprint_Chicago.jpg?width=300&name=Embroidery_Specialty_Puff_Embroidery_Sharprint_Chicago.jpg"
            alt="Puff Embroidery"
            title="Puff Embroidery"
            className="w-72 md:w-80 border-0"
          />
        </div>

        {/* Text */}
        <div className="flex-1">
          <h4>Puff Embroidery</h4>
          <p>
            Puff embroidery creates text and designs with bold, raised impact. 
            It works best for block-style lettering and simple shapes, giving your garments a standout, tactile look. 
            Thin lines or intricate details are not recommended for this style.
          </p>
        </div>
      </div>
    </div>
    <div className="embroidery-spacer my-6 md:my-8">
      {/* Empty space for layout spacing */}
      <div style={{ height: '25px' }}></div>
    </div>
   <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 my-6">
      <div className="flex-shrink-0">
        <img
          src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Specialty_Embroidery/Embroidery_Specialty_Applique_Sharprint_Chicago.jpg?width=300&name=Embroidery_Specialty_Applique_Sharprint_Chicago.jpg"
          alt="Applique Embroidery"
          title="Applique Embroidery"
          className="w-72 md:w-80 border-0"
        />
      </div>
      <div className="flex-1">
        <h4>Applique</h4>
        <p>
          Most recognized as collegiate sweatshirt decoration, this cut material and embroidery combination can be applied to caps, bags, and countless other fabrics.
        </p>
      </div>
    </div>
                  </div>
              </div>
          </div>
          </>
    </div>
  )
}
